/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignDeckDTO,
  CreateDeckDTO,
  CreateDeckExerciseDTO,
  DeckDTO,
  DeckValidationDTO,
  DeleteDeckDTO,
  ExerciseDTO,
  GetUserDecksDTO,
  RemoveDeckExerciseDTO,
  UpdateDeckDTO,
  UpdateDeckExerciseDTO,
} from '../models/index';
import {
    AssignDeckDTOFromJSON,
    AssignDeckDTOToJSON,
    CreateDeckDTOFromJSON,
    CreateDeckDTOToJSON,
    CreateDeckExerciseDTOFromJSON,
    CreateDeckExerciseDTOToJSON,
    DeckDTOFromJSON,
    DeckDTOToJSON,
    DeckValidationDTOFromJSON,
    DeckValidationDTOToJSON,
    DeleteDeckDTOFromJSON,
    DeleteDeckDTOToJSON,
    ExerciseDTOFromJSON,
    ExerciseDTOToJSON,
    GetUserDecksDTOFromJSON,
    GetUserDecksDTOToJSON,
    RemoveDeckExerciseDTOFromJSON,
    RemoveDeckExerciseDTOToJSON,
    UpdateDeckDTOFromJSON,
    UpdateDeckDTOToJSON,
    UpdateDeckExerciseDTOFromJSON,
    UpdateDeckExerciseDTOToJSON,
} from '../models/index';

export interface DeckAddExerciseToDeckRequest {
    createDeckExerciseDTO: CreateDeckExerciseDTO;
}

export interface DeckAssignDeckToUserRequest {
    assignDeckDTO: AssignDeckDTO;
}

export interface DeckCreateDeckRequest {
    createDeckDTO: CreateDeckDTO;
}

export interface DeckDeleteDeckRequest {
    deleteDeckDTO: DeleteDeckDTO;
}

export interface DeckGetDeckByIdRequest {
    deckId: string;
}

export interface DeckGetDecksByUserIdRequest {
    getUserDecksDTO: GetUserDecksDTO;
}

export interface DeckRemoveDeckExerciseRequest {
    removeDeckExerciseDTO: RemoveDeckExerciseDTO;
}

export interface DeckUnassignDeckFromUserRequest {
    assignDeckDTO: AssignDeckDTO;
}

export interface DeckUpdateDeckRequest {
    updateDeckDTO: UpdateDeckDTO;
}

export interface DeckUpdateDeckExerciseRequest {
    updateDeckExerciseDTO: UpdateDeckExerciseDTO;
}

export interface DeckValidateRequest {
    deckId: string;
}

/**
 * 
 */
export class DeckApi extends runtime.BaseAPI {

    /**
     */
    async deckAddExerciseToDeckRaw(requestParameters: DeckAddExerciseToDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExerciseDTO>> {
        if (requestParameters['createDeckExerciseDTO'] == null) {
            throw new runtime.RequiredError(
                'createDeckExerciseDTO',
                'Required parameter "createDeckExerciseDTO" was null or undefined when calling deckAddExerciseToDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deck/add-exercise`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDeckExerciseDTOToJSON(requestParameters['createDeckExerciseDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseDTOFromJSON(jsonValue));
    }

    /**
     */
    async deckAddExerciseToDeck(requestParameters: DeckAddExerciseToDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExerciseDTO> {
        const response = await this.deckAddExerciseToDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deckAssignDeckToUserRaw(requestParameters: DeckAssignDeckToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assignDeckDTO'] == null) {
            throw new runtime.RequiredError(
                'assignDeckDTO',
                'Required parameter "assignDeckDTO" was null or undefined when calling deckAssignDeckToUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deck/assign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignDeckDTOToJSON(requestParameters['assignDeckDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deckAssignDeckToUser(requestParameters: DeckAssignDeckToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deckAssignDeckToUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deckCreateDeckRaw(requestParameters: DeckCreateDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckDTO>> {
        if (requestParameters['createDeckDTO'] == null) {
            throw new runtime.RequiredError(
                'createDeckDTO',
                'Required parameter "createDeckDTO" was null or undefined when calling deckCreateDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deck`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDeckDTOToJSON(requestParameters['createDeckDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeckDTOFromJSON(jsonValue));
    }

    /**
     */
    async deckCreateDeck(requestParameters: DeckCreateDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckDTO> {
        const response = await this.deckCreateDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deckDeleteDeckRaw(requestParameters: DeckDeleteDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['deleteDeckDTO'] == null) {
            throw new runtime.RequiredError(
                'deleteDeckDTO',
                'Required parameter "deleteDeckDTO" was null or undefined when calling deckDeleteDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deck`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteDeckDTOToJSON(requestParameters['deleteDeckDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async deckDeleteDeck(requestParameters: DeckDeleteDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deckDeleteDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deckGetDeckByIdRaw(requestParameters: DeckGetDeckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckDTO>> {
        if (requestParameters['deckId'] == null) {
            throw new runtime.RequiredError(
                'deckId',
                'Required parameter "deckId" was null or undefined when calling deckGetDeckById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/deck/byId/{deckId}`.replace(`{${"deckId"}}`, encodeURIComponent(String(requestParameters['deckId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeckDTOFromJSON(jsonValue));
    }

    /**
     */
    async deckGetDeckById(requestParameters: DeckGetDeckByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckDTO> {
        const response = await this.deckGetDeckByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deckGetDecksByUserIdRaw(requestParameters: DeckGetDecksByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeckDTO>>> {
        if (requestParameters['getUserDecksDTO'] == null) {
            throw new runtime.RequiredError(
                'getUserDecksDTO',
                'Required parameter "getUserDecksDTO" was null or undefined when calling deckGetDecksByUserId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deck/byUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUserDecksDTOToJSON(requestParameters['getUserDecksDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeckDTOFromJSON));
    }

    /**
     */
    async deckGetDecksByUserId(requestParameters: DeckGetDecksByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeckDTO>> {
        const response = await this.deckGetDecksByUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deckGetUserDecksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeckDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/deck`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeckDTOFromJSON));
    }

    /**
     */
    async deckGetUserDecks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeckDTO>> {
        const response = await this.deckGetUserDecksRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async deckListAllDecksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeckDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/deck/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeckDTOFromJSON));
    }

    /**
     */
    async deckListAllDecks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeckDTO>> {
        const response = await this.deckListAllDecksRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async deckRemoveDeckExerciseRaw(requestParameters: DeckRemoveDeckExerciseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['removeDeckExerciseDTO'] == null) {
            throw new runtime.RequiredError(
                'removeDeckExerciseDTO',
                'Required parameter "removeDeckExerciseDTO" was null or undefined when calling deckRemoveDeckExercise().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deck/remove-exercise`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveDeckExerciseDTOToJSON(requestParameters['removeDeckExerciseDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deckRemoveDeckExercise(requestParameters: DeckRemoveDeckExerciseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deckRemoveDeckExerciseRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deckUnassignDeckFromUserRaw(requestParameters: DeckUnassignDeckFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assignDeckDTO'] == null) {
            throw new runtime.RequiredError(
                'assignDeckDTO',
                'Required parameter "assignDeckDTO" was null or undefined when calling deckUnassignDeckFromUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deck/unassign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignDeckDTOToJSON(requestParameters['assignDeckDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deckUnassignDeckFromUser(requestParameters: DeckUnassignDeckFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deckUnassignDeckFromUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deckUpdateDeckRaw(requestParameters: DeckUpdateDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateDeckDTO'] == null) {
            throw new runtime.RequiredError(
                'updateDeckDTO',
                'Required parameter "updateDeckDTO" was null or undefined when calling deckUpdateDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deck`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDeckDTOToJSON(requestParameters['updateDeckDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deckUpdateDeck(requestParameters: DeckUpdateDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deckUpdateDeckRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deckUpdateDeckExerciseRaw(requestParameters: DeckUpdateDeckExerciseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExerciseDTO>> {
        if (requestParameters['updateDeckExerciseDTO'] == null) {
            throw new runtime.RequiredError(
                'updateDeckExerciseDTO',
                'Required parameter "updateDeckExerciseDTO" was null or undefined when calling deckUpdateDeckExercise().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deck/update-exercise`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDeckExerciseDTOToJSON(requestParameters['updateDeckExerciseDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseDTOFromJSON(jsonValue));
    }

    /**
     */
    async deckUpdateDeckExercise(requestParameters: DeckUpdateDeckExerciseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExerciseDTO> {
        const response = await this.deckUpdateDeckExerciseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deckValidateRaw(requestParameters: DeckValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckValidationDTO>> {
        if (requestParameters['deckId'] == null) {
            throw new runtime.RequiredError(
                'deckId',
                'Required parameter "deckId" was null or undefined when calling deckValidate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/deck/validate/{deckId}`.replace(`{${"deckId"}}`, encodeURIComponent(String(requestParameters['deckId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeckValidationDTOFromJSON(jsonValue));
    }

    /**
     */
    async deckValidate(requestParameters: DeckValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckValidationDTO> {
        const response = await this.deckValidateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
